import { createOrder as _createOrder } from '../cart/cart.service';

export const createOrder = _createOrder;
